// @ts-nocheck
import { useEffect, useRef, useState } from 'react';

/**
 * @param {{
 *  items: { id: string, label: string, onClick: () => void, danger?: boolean }[],
 *  label?: string
 * }} props
 */
export default function OverflowMenu({ items, label = 'More actions' }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(/** @type {HTMLDivElement | null} */ (null));
  useEffect(() => {
    const onDoc = (/** @type {MouseEvent} */ event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const onKey = (/** @type {KeyboardEvent} */ event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      window.removeEventListener('keydown', onKey);
    };
  }, []);
  return (
    <div ref={rootRef} className="relative inline-block text-left">
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={label}
        className="h-8 w-8 rounded-lg text-lg leading-none text-slate-700 hover:bg-slate-100"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((value) => !value);
        }}
      >
        ⋯
      </button>
      {open ? (
        <div role="menu" className="absolute right-0 z-20 mt-1 min-w-[180px] rounded-lg border border-slate-200 bg-white py-1 shadow-lg">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              role="menuitem"
              className={`block w-full px-3 py-2 text-left text-sm ${item.danger ? 'text-[#B91C1C]' : 'text-slate-800'} hover:bg-slate-50`}
              onClick={(event) => {
                event.stopPropagation();
                setOpen(false);
                item.onClick();
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
